import { axios, API } from './config';

export const weeklyEventSheetsAPI = {
  list: async () => (await axios.get(`${API}/weekly-event-sheets`)).data,
  byWeek: async (weekStart) => (await axios.get(`${API}/weekly-event-sheets/by-week/${weekStart}`)).data,
  autoPopulate: async (weekStart) =>
    (await axios.get(`${API}/weekly-event-sheets/auto-populate`, { params: { week_start: weekStart } })).data,
  get: async (id) => (await axios.get(`${API}/weekly-event-sheets/${id}`)).data,
  create: async (payload) => (await axios.post(`${API}/weekly-event-sheets`, payload)).data,
  update: async (id, payload) => (await axios.put(`${API}/weekly-event-sheets/${id}`, payload)).data,
  remove: async (id) => (await axios.delete(`${API}/weekly-event-sheets/${id}`)).data,
};
